import { Swiper } from "swiper"
import {
  Navigation,
  Autoplay,
  Keyboard,
  Parallax,
  Mousewheel,
  Pagination,
} from "swiper/modules"

function introSlider() {
  //   console.log("introSlider is working...")
  const initSwiper = () => {
    const sliderElement = document.querySelector(".intro-swiper")

    if (!sliderElement) {
      return
    }

    new Swiper(sliderElement, {
      modules: [Navigation, Autoplay, Keyboard, Parallax, Mousewheel],
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      speed: 1000,
      loop: true,
      slidesPerView: 1,
      parallax: true,
      effect: "slide",
      spaceBetween: 100,
      mousewheel: {
        forceToAxis: true,
      },
      keyboard: {
        enabled: true,
      },
      grabCursor: true,
      centeredSlides: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSwiper, { once: true })
    return
  }

  initSwiper()
}
function tariffSlider() {
  //   console.log("tariffSlider is working...")
  let tariffSwiper = null
  const sliderSelector = ".tariff-swiper"

  const initTariffSlider = () => {
    if (tariffSwiper) {
      return
    }

    const sliderElement = document.querySelector(sliderSelector)

    if (!sliderElement) {
      return
    }

    const paginationElement = sliderElement.querySelector(".swiper-pagination")

    if (!paginationElement) {
      return
    }

    tariffSwiper = new Swiper(sliderElement, {
      modules: [Keyboard, Mousewheel, Pagination],
      loop: false,
      effect: "slide",
      slidesPerView: 1,
      spaceBetween: 12,
      centeredSlides: true,
      watchOverflow: true,
      breakpointsBase: "window",
      pagination: {
        el: paginationElement,
        clickable: true,
        enabled: true,
      },

      breakpoints: {
        680: {
          slidesPerView: 2,
          spaceBetween: 16,
          centeredSlides: true,
          pagination: {
            enabled: true,
          },
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
          centeredSlides: false,
          pagination: {
            enabled: false,
          },
        },
      },

      mousewheel: {
        forceToAxis: true,
      },
      keyboard: {
        enabled: true,
      },
      grabCursor: true,
    })
  }

  const destroyTariffSlider = () => {
    if (!tariffSwiper) {
      return
    }

    tariffSwiper.destroy(true, true)
    tariffSwiper = null
  }

  const syncTariffSlider = () => {
    if (window.innerWidth <= 1200) {
      initTariffSlider()
      return
    }

    destroyTariffSlider()
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncTariffSlider, {
      once: true,
    })
  } else {
    syncTariffSlider()
  }

  window.addEventListener("resize", syncTariffSlider)
}

export { introSlider, tariffSlider }
